import React, { useState } from 'react'
import { Btn, CustomModal, InputText } from '../../../../components'

function ModalCancelarCte({ cte, isVisible, onCancel, onSave, onError }) {
  if (!cte) return null
  // Vars

  // Hooks
  const [justificativa, setJustificativa] = useState(cte.justificativa ? cte.justificativa : '')

  // Events
  const onBtnSalvarClicked = async () => {
    if (justificativa.trim().length <= 15) {
      onError('A justificativa deve conter pelo menos 15 caracteres')
      return
    }
    onSave({ ...cte, justificativa: justificativa })
  }

  // Render
  return (
    <CustomModal header="Cancelar CTe" isVisible={isVisible} onClose={onCancel}>
      <form className="p-grid">
        <div className="p-col-12">
          <InputText
            label="Justificativa :"
            marginTop={10}
            value={justificativa}
            onChange={value => setJustificativa(value)}
          />
        </div>
        <div className="p-col-12">
          <Btn onClick={onBtnSalvarClicked}>Salvar</Btn>
        </div>
      </form>
    </CustomModal>
  )
}

export default ModalCancelarCte
